var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/app.module.ts.pre-build-optimizer.js